import React from 'react';
import { IconType } from 'react-icons';
import styled, { css } from 'styled-components';
import { colors } from './Styles';

export enum RhInputMode {
  underlined,
  bordered,
  subtle,
}

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  /** from react-icons package */
  icon?: IconType;
  /** input mode  */
  mode?: RhInputMode;
  /** container style */
  containerStyle?: React.CSSProperties;
  /** ref for input */
  inputRef?:
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | null
    | undefined;
}

export const RhInput = (props: Props) => {
  const { icon: Icon, mode = RhInputMode.bordered, containerStyle, inputRef, ...rest } = props;
  return (
    <RhInputDiv mode={mode} style={containerStyle}>
      {Icon && <Icon color={colors.grey} />} <Input {...rest} ref={inputRef} />
    </RhInputDiv>
  );
};

export const RhInputDiv = styled.div<{ mode: RhInputMode }>`
  display: flex;
  align-items: center;

  ${({ mode }) => {
    switch (mode) {
      case RhInputMode.bordered:
        return css`
          padding: 10px 20px;
          border: 1.5px solid ${colors.lightGrey};
          border-radius: 32px;
        `;
      case RhInputMode.underlined:
        return css`
          border-bottom: 2px solid ${colors.subtle};
          padding: 4px 0;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 19px;
          color: #767676;
        `;
      case RhInputMode.subtle:
        return css`
          & > input,
          & > textarea {
            padding: 8px;
            background: ${colors.background};
            border: 1px solid ${colors.faintGrey};
            border-radius: 10px;
            color: ${colors.normal};
          }
        `;
      default:
        break;
    }
  }}

  & > :not(:last-child) {
    margin-right: 10px;
  }
`;

const Input = styled.input`
  all: unset;
  // but just to be sure:
  appearance: none;
  outline: none;
  border: none;

  font-weight: 600;
  font-size: 16px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
  }
`;
